import { lazy, Suspense } from "react";
import BlaBlaHead from "./BlaBlaHead";
import BlaBlaMission from "./BlaBlaMission";

const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));
const BlaBlaAction = lazy(() => import("./BlaBlaAction"));
const BlaBlaAllin = lazy(() => import("./BlaBlaAllin"));
const BlaBlaBusiness = lazy(() => import("./BlaBlaBusiness"));
const BlaBlaFeature = lazy(() => import("./BlaBlaFeature"));
const BlaBlaMinimum = lazy(() => import("./BlaBlaMinimum"));
const BlaBlaTech = lazy(() => import("./BlaBlaTech"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const OnDemandWork = lazy(() => import("../onDemand/OnDemandWork"));

const HeadData = {
  title: "Launch a Modern Carpooling App Like BlaBlaCar",
  description: "Our carpooling app services offer cutting-edge features, sleek design, and robust tools to digitalize and scale your shared mobility business across Germany and Europe.",
  image: "/assets/home/blabla-banner.webp",
  backImage: "/assets/home/blabla-banner-back.webp",
  btn: "Schedule A Demo",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "blabla Clone App",
        slug: ""
      },
    ]
  }
};

const missionData = {
  mission: "Our Mission",
  titlePart1: "We develop",
  titlePart2: "competitive and scalable mobility",
  titlePart3: "solutions for operators worldwide.",
  description: "With over 5+ years of experience on Europe’s busiest roads, we’ve built a reliable platform backed by operational expertise and tailored marketing strategies. From our origins as a traditional mobility service in 2020 to becoming a leading mobility technology provider in 2025, we empower transport operators to stay independent and achieve growth in today’s fast-evolving shared mobility landscape.",
}

const businessData = {
  titlePart1: "Carpooling",
  titlePart2: "Solutions for All Kinds",
  titlePart3: "of Shared Mobility Concepts",
  description: "Whatever your shared mobility vision, we deliver the right solution for you.",
  boxes: [
    {
      image: "/assets/home/blabla-business-icon1.webp",
      heading: "Carpooling/Ridesharing Marketplace",
      description: "Launch a smart, scalable carpooling platform like BlaBlaCar to effortlessly connect daily commuters, reduce travel costs, ease traffic congestion, and promote eco-friendly, shared mobility across Germany and Europe.",
    },
    {
      image: "/assets/home/blabla-business-icon2.webp",
      heading: "Shared Mobility Platform",
      description: "Build a seamless, tech-driven shared mobility platform that connects people traveling in the same direction. Offer commuters a convenient, affordable, and eco-conscious way to share rides while reducing traffic and emissions.",
    },
    {
      image: "/assets/home/blabla-business-icon3.webp",
      heading: "peer-to-peer Vehicle Sharing",
      description: "Develop a reliable peer-to-peer carpooling app that connects travelers heading in the same direction, offering cost-effective, sustainable commuting with live tracking, secure payments, user reviews, and flexible ride options.",
    },
  ]
}

const featureData = {
  titlePart1: "Features Of",
  titlePart2: "BlaBlaCar",
  titlePart3: "Clone",
  description: "Our BlaBlaCar Clone comes packed with modern features that guarantee a seamless, secure, and user-friendly carpooling experience:",
  boxes: [
    {
      image: "/assets/home/bla-feature-1.webp",
      heading: "Login / Register",
      description: "Fast, simple registration via email or popular social media accounts.",
    },
    {
      image: "/assets/home/bla-feature-2.webp",
      heading: "Find Ride",
      description: "Search and book rides directly to your chosen destination.",
    },
    {
      image: "/assets/home/bla-feature-3.webp",
      heading: "Search Option",
      description: "Easily filter rides by shared preferences, vehicle type, or route.",
    },
    {
      image: "/assets/home/bla-feature-4.webp",
      heading: "Quick Match",
      description: "Intelligent suggestions connect passengers and car owners with similar routes in seconds.",
    },
    {
      image: "/assets/home/bla-feature-5.webp",
      heading: "Time & Fare Estimation",
      description: "Transparent fare, time, and distance estimates provided for both riders and car owners before every trip.",
    },
    {
      image: "/assets/home/bla-feature-6.webp",
      heading: "App Notification",
      description: "Instant notifications for trip updates, ride status, and important alerts.",
    },
    {
      image: "/assets/home/bla-feature-7.webp",
      heading: "Real Time Tracking",
      description: "Live location tracking for passengers and car owners via integrated Google Maps.",
    },
    {
      image: "/assets/home/bla-feature-8.webp",
      heading: "Navigation System",
      description: "Built-in navigation for efficient pickups, drop-offs, and route optimization.",
    },
    {
      image: "/assets/home/bla-feature-9.webp",
      heading: "Review & Ratings",
      description: "A rating system for both passengers and car owners to build trust and ensure service quality.",
    },
    {
      image: "/assets/home/bla-feature-10.webp",
      heading: "Custom Checkout",
      description: "Supports popular payment gateways including PayPal, Stripe, and region-specific options.",
    },
    {
      image: "/assets/home/bla-feature-11.webp",
      heading: "VoIP Calling",
      description: "In-app internet calling for secure, private communication between riders and car owners.",
    },
    {
      image: "/assets/home/bla-feature-12.webp",
      heading: "SOS Button",
      description: "Instant emergency alert feature to notify saved contacts during critical situations.",
    },
    {
      image: "/assets/home/bla-feature-13.webp",
      heading: "Invite Friends",
      description: "Easily invite friends and family to join the carpooling platform.",
    },
    {
      image: "/assets/home/bla-feature-14.webp",
      heading: "Promo Codes",
      description: "Offer promotional codes and discounts to attract and retain users.",
    },
    {
      image: "/assets/home/bla-feature-15.webp",
      heading: "Ride Scheduling Flexibility",
      description: "Car owners can easily publish, modify, or cancel their upcoming rides.",
    },
    {
      image: "/assets/home/bla-feature-16.webp",
      heading: "Multiple Languages",
      description: "Multi-language support, ideal for Germany’s diverse, international user base.",
    },
  ]
}

const techData = {
  titlePart1: "Mobility Infotech Powering",
  titlePart2: "the Future of Carpooling Technology",
  description: "Mobility Infotech builds next-generation, user-friendly carpooling apps with real-time features that drive operational efficiency and shape the future of shared mobility. We help businesses optimize processes, reduce costs, and lead the smart transportation revolution.",
  image: "/assets/home/bla-tech-img.webp",
  boxes: [
    {
      image: "/assets/home/bla-tech-icon1.webp",
      heading: "Customize as per your Needs",
      description: "Launch your carpooling business with feature-rich apps and a custom website – built smart, scalable, and ready to succeed in the German and European mobility market.",
    },
    {
      image: "/assets/home/bla-tech-icon2.webp",
      heading: "Technologically Sound Solutions",
      description: "Customize your BlaBlaCar-style app to suit your specific business requirements. From carpooling to peer-to-peer shared mobility, we help you select the best features to meet your needs.",
    },
    {
      image: "/assets/home/bla-tech-icon3.webp",
      heading: "Find and Offer ride",
      description: "Our experienced development team tackles every technical challenge, ensuring your carpooling business runs smoothly, grows faster, and delivers maximum return on investment.",
    },
    {
      image: "/assets/home/bla-tech-icon4.webp",
      heading: "Advanced referral program",
      description: "Integrate an advanced referral program with multi-payment options for a flexible, hassle-free, and secure carpooling experience.",
    }
  ]

}

const actionData = {
  imageBack: "/assets/home/bla-action-back.webp",
  title: "Don’t lose touch with your market",
  description: "Advance with confidence partner with Mobility Infotech for future-ready operations.",
  btn: "get in touch"
}

const allInData = {
  titlePart1: "All-in-One Features",
  titlePart2: "for Riders & Admins",

  feature1: {
    image: "/assets/home/bla-rider-main.webp",
    leftBoxes: [
      {
        title: "Unique Registration",
        description: "Simple, secure sign-up process for passengers.",
        image: "/assets/home/bla-rider-1.webp",
      },
      {
        title: "Seamless Profile Making",
        description: "Complete passenger profiles for better ride matching and safety.",
        image: "/assets/home/bla-rider-2.webp",
      },
      {
        title: "Locational Detailing",
        description: "Precise location inputs for efficient route planning.",
        image: "/assets/home/bla-rider-3.webp",
      },
      {
        title: "Feasible Ride Selection",
        description: "Option to choose from available rides according to your feasible time and date.",
        image: "/assets/home/bla-rider-4.webp",
      },
    ],
    rightBoxes: [
      {
        title: "Instant Fare Details",
        description: "Transparent fare details provided before booking.",
        image: "/assets/home/bla-rider-5.webp",
      },
      {
        title: "Smart Tracking",
        description: "Live ride tracking directly within the app.",
        image: "/assets/home/bla-rider-6.webp",
      },
      {
        title: "SOS Alerts",
        description: "Emergency alerts for enhanced passenger safety.",
        image: "/assets/home/bla-rider-7.webp",
      },
      {
        title: "Review/Ratings",
        description: "Transparent review system to foster trust within the community.",
        image: "/assets/home/bla-rider-8.webp",
      },
    ],
  },

  feature2: {
    image: "/assets/home/bla-admin-main.webp",
    leftBoxes: [
      {
        title: "Panels Accessibility",
        description: "Control who can access different sections of your admin dashboard by setting security levels.",
        image: "/assets/home/bla-admin-1.webp",
      },
      {
        title: "Profile Management",
        description: "Easily manage and update profiles to maintain safety, trust, and high service standards.",
        image: "/assets/home/bla-rider-2.webp",
      },
      {
        title: "Transaction Analysis",
        description: "Track all platform transactions, revenue streams, and key financial metrics with real-time analytics.",
        image: "/assets/home/bla-admin-3.webp",
      },
      {
        title: "Car Owner ID Validation",
        description: "Allow car owners to verify their identity with valid documents to enhance trust and safety on the platform.",
        image: "/assets/home/bla-admin-4.webp",
      },
    ],
    rightBoxes: [
      {
        title: "Total Earning Analysis",
        description: "Access comprehensive earning reports for your business and platform revenue to monitor performance.",
        image: "/assets/home/bla-admin-5.webp",
      },
      {
        title: "Ride Cost Summary for Car Owners",
        description: "Car owners can view a summary of ride contributions received, promoting transparency.",
        image: "/assets/home/bla-admin-6.webp",
      },
      {
        title: "Community Review Monitoring",
        description: "Monitor and moderate reviews for both passengers and car owners",
        image: "/assets/home/bla-rider-8.webp",
      },
      {
        title: "Configure Settings",
        description: "Customize app settings, pricing structures, and more through a admin dashboard.",
        image: "/assets/home/bla-admin-8.webp",
      },
    ],
  },
}

const minimumData = {
  tagline: "Why quality matters more than price!",
  titlePart1: "Think beyond",
  titlePart2: "Minimum Viable Product",
  description: "Launch with Mobility Infotech’s BlaBlaCar Clone — designed for growth, reliability, and high user satisfaction. Our ridesharing solution goes beyond basic functionality, offering the performance and scalability needed to succeed in today’s demanding mobility industry.",
  box1: {
    image: "/assets/home/lyft-minimum-1.webp",
    title: "Transparent Development Process",
  },
  box2: {
    image: "/assets/home/lyft-minimum-2.webp",
    title: "Essential Features Built-In from Day One",
  },
  box3: {
    image: "/assets/home/lyft-minimum-3.webp",
    title: "Unlimited Updates – No Hidden Fees",
  },
  box4: {
    image: "/assets/home/lyft-minimum-4.webp",
    title: "Elegant UI/UX Integrated",
  },
  box5: {
    image: "/assets/home/lyft-minimum-5.webp",
    title: "Enterprise-Grade Post-Launch Support",
  },
  box6: {
    image: "/assets/home/lyft-minimum-6.webp",
    title: "Optimized for High Performance and Reliability",
  },
  btn: "SEE OUR PRICING PLAN",
}

const faqData = [
  {
    id: "0",
    question: "01. How customizable is the BlaBlaCar Clone app for my business?",
    answer: "Our solution is fully customizable to match your business model, branding, and specific operational requirements. From the user interface to payment gateways, languages, and advanced features, we tailor the app to your vision.",
  },
  {
    id: "1",
    question: "02. Can I launch the app in multiple languages for different regions?",
    answer: "Yes, our BlaBlaCar Clone supports multiple languages, making it ideal for Germany’s multicultural market and expanding across other European countries seamlessly.",
  },
  {
    id: "2",
    question: "03. Is the BlaBlaCar Clone app GDPR compliant?",
    answer: "Absolutely. We understand the importance of data privacy in Europe. Our app is designed to comply with GDPR regulations, ensuring your users' data is protected and managed responsibly.",
  },
  {
    id: "3",
    question: "04. Does the app support real-time ride tracking?",
    answer: "Yes, the app includes real-time location tracking for both passengers and car owners, offering safety, transparency, and efficient route management through integrated Google Maps.",
  },
  {
    id: "4",
    question: "05. What payment options are supported?",
    answer: "Our platform supports multiple popular payment gateways such as PayPal and Stripe, and can be integrated with region-specific or preferred payment solutions to suit your target market.",
  },
  {
    id: "5",
    question: "06.How secure is the communication between car owners and passengers?",
    answer: "The app features VoIP calling, allowing secure, internet-based communication without sharing personal contact details. Additional in-app chat options can also be implemented.",
  },
];

export default function BlaBlaClone() {
  return (
    <>
      <BlaBlaHead data={HeadData} />
      <BlaBlaMission data={missionData} />

      <Suspense fallback={null}>
        <BlaBlaBusiness data={businessData} />
        <BlaBlaFeature data={featureData} />
        <BlaBlaTech data={techData} />
        <BlaBlaAction data={actionData} />
        <BlaBlaAllin data={allInData} />
        <BlaBlaMinimum data={minimumData} />
        <div className="solution-case">
          <OnDemandWork />
        </div>
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
